import * as Yup from "yup";
import {
  getFieldRequiredMessage,
  getMin5PasswordChar,
  getMin6PasswordMessage,
  getOnlyNumMessage,
  getPasswordError,
  getPasswordMatchMessage,
  getValidArabicMessage,
  getValidEmail,
  getNameVarFieldRequiredMessage,
} from "./ValidationMessages";

const arabicNameOrNumberPattern = /^[\u0600-\u06FF0-9\s\p{P}\p{S}]+$/u;
const arabicNameOrNumberPatternVar =
  /^(?:[\u0600-\u06FF0-9\s\p{P}\p{S}]+|\{\{name\}\})+$/u;

const englishWithNamePattern = /^(?:[A-Za-z0-9\s\p{P}\p{S}]|\{\{name\}\})+$/u;
const englishWithoutNamePattern =
  /^(?!.*\{\{name\}\})[A-Za-z0-9\s\p{P}\p{S}]+$/;

const onlyNumberPattern = /^[0-9]+$/;
const passwordPattern = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])/;

const noOnlySpacesOrNumbers = Yup.string()
  .test(
    "no-only-spaces",
    "Field cannot be empty spaces",
    (value) => value?.trim().length > 0
  )
  .test("no-only-numbers", "Field cannot be only numbers", (value) =>
    isNaN(value)
  );

const createSchemaShape = (shape) => {
  return Yup.object().shape(shape);
};

const signUpSchema = () => {
  const shape = {
    name: Yup.string()
      .required(getFieldRequiredMessage()),
    phoneNumber: Yup.string().matches(onlyNumberPattern,"Must be number")
      .required(getFieldRequiredMessage()),
    email: Yup.string()
      .required(getFieldRequiredMessage())
      .email()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        getValidEmail()
      ),
    password: Yup.string()
      .min(5, getMin5PasswordChar())
      .required(getFieldRequiredMessage()),
    hasAgreedTnC: Yup.bool()
      .oneOf([true], "You must accept the Terms and Conditions").required(getFieldRequiredMessage()),
  };

  return createSchemaShape(shape);
};
const orgnisationDetailsSchema = () => {
  const shape = {
    companyName: Yup.string().required(getFieldRequiredMessage()),
    commercialNumber: Yup.number().required(getFieldRequiredMessage()),
    countryId: Yup.string().required(getFieldRequiredMessage()),
    // email: Yup.string().required(getFieldRequiredMessage()).email()
    //   .matches(
    //     /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    //     getValidEmail()
    //   ),
    vatNumber: Yup.number().required(getFieldRequiredMessage()),

  };

  return createSchemaShape(shape);
};
const loginSchema = () => {
  const shape = {
    email: Yup.string()
      .required(getFieldRequiredMessage())
      .email()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        getValidEmail()
      ),
    password: Yup.string()
      .min(5, getMin5PasswordChar())
      .required(getFieldRequiredMessage()),
  };

  return createSchemaShape(shape);
};

const resetPasswordSchema = () => {
  const shape = {
    email: Yup.string().required(getFieldRequiredMessage()),
  };

  return createSchemaShape(shape);
};

const verifyCodeSchema = () => {
  const shape = {
    otp: Yup.string().required(getFieldRequiredMessage()),
  };

  return createSchemaShape(shape);
};

const newPasswordSchema = (mode) => {
  var shape = {
    newPassword: Yup.string()
      .min(6, getMin6PasswordMessage())
      .matches(passwordPattern, getPasswordError())
      .required(getFieldRequiredMessage()),
    confirmPassword: Yup.string()
      .required(getFieldRequiredMessage())
      .oneOf([Yup.ref("newPassword"), null], getPasswordMatchMessage()),
  };

  return createSchemaShape(shape);
};

const addMeetingRoomSchema = () => {
  const shape = {
    imageUrls: Yup.array().min(1, "Please add at least one amenity."),
    name: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters"),
    nameAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
    description: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters"),
    descriptionAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),

    branchId: Yup.string().required(getFieldRequiredMessage()),
    cityId: Yup.string().required(getFieldRequiredMessage()),
    numberOfSeats: Yup.string().required(getFieldRequiredMessage()),
    price: Yup.string()
      .required(getFieldRequiredMessage())
      .typeError(getFieldRequiredMessage())
      .matches(onlyNumberPattern, getOnlyNumMessage()),
    numberOfSeats: Yup.string()
      .required(getFieldRequiredMessage())
      .typeError(getFieldRequiredMessage())
      .matches(onlyNumberPattern, getOnlyNumMessage()),
    customPrice: Yup.array().of(
      Yup.object().shape({
        // days: Yup.array()
        //   .of(Yup.string().required(getFieldRequiredMessage()))
        //   .min(1, "Please select at least one day."),
        days: Yup.string().required(getFieldRequiredMessage()),
        startTime: Yup.string().required(getFieldRequiredMessage()),
        endTime: Yup.string().required(getFieldRequiredMessage()),
        price: Yup.string()
          .required(getFieldRequiredMessage())
          .typeError(getFieldRequiredMessage())
          .matches(onlyNumberPattern, getOnlyNumMessage()),
      })
    ),
    // .min(1, "Please add at least one custom price.")
    amenities: Yup.array().min(1, "Please add at least one amenity."),
  };

  return createSchemaShape(shape);
};

const addWorkspaceSchema = () => {
  const shape = {
    imageUrls: Yup.array().min(1, "Please add at least one amenity."),
    name: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters"),
    nameAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
    description: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters"),
    descriptionAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),

    branchId: Yup.string().required(getFieldRequiredMessage()),
    cityId: Yup.string().required(getFieldRequiredMessage()),
    timePeriods: Yup.array()
      .of(
        Yup.object().shape({
          name: noOnlySpacesOrNumbers
            .required(getFieldRequiredMessage())
            .max(100, "Field must be at most 100 characters"),
          nameAr: noOnlySpacesOrNumbers
            .required(getFieldRequiredMessage())
            .max(100, "Field must be at most 100 characters")
            .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
          numberOfSeats: Yup.number()
            .required(getFieldRequiredMessage())
            .min(0, "Number of seats must be at least 1."),
          price: Yup.number()
            .nullable()
            .required(getFieldRequiredMessage())
            .min(1, "Price must be at least 1."),
          // discount: Yup.number()
          // .required(getFieldRequiredMessage())
          // .nullable()
          // .min(0, "Discount cannot be negative."),
          // .max(100, "Discount cannot exceed 100.")
          time: Yup.object().shape({
            start: Yup.string().required(getFieldRequiredMessage()),
            end: Yup.string().required(getFieldRequiredMessage()),
          }),
        })
      )
      .min(1, "At least one time period is required."),
    amenities: Yup.array().min(1, "Please add at least one amenity."),
  };

  return createSchemaShape(shape);
};

const createWorkshopSchema = () => {
  const shape = {
    imageUrls: Yup.array().min(1, "Please add at least one amenity."),
    name: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters"),

    nameAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
    description: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters"),
    descriptionAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
    topics: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters"),
    topicsAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
    branchId: Yup.string().required(getFieldRequiredMessage()),
    cityId: Yup.string().required(getFieldRequiredMessage()),
    childSpaceId: Yup.string().required(getFieldRequiredMessage()),
    workshopType: Yup.number().required(getFieldRequiredMessage()),
    childSpaceId: Yup.mixed().when("$workshopType", {
      is: (val) => val === 3,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required(getFieldRequiredMessage()),
    }),
    amenities: Yup.array().min(1, "Please add at least one amenity."),
    workShopDetails: Yup.object().shape({
      trainerShare: Yup.number()
        .required(getFieldRequiredMessage())
        .min(0, "Trainer's share must be at least 0")
        .max(100, "Trainer's share cannot exceed 100"),
      companyShare: Yup.number()
        .required(getFieldRequiredMessage())
        .min(0, "Company's share must be at least 0")
        .max(100, "Company's share cannot exceed 100"),
      trainerName: noOnlySpacesOrNumbers.required(getFieldRequiredMessage()),
      ageGroup: Yup.object().shape({
        min: Yup.number()
          .required(getFieldRequiredMessage())
          .min(0, "Minimum age must be at least 0")
          .when("max", (max, schema) =>
            max
              ? schema.max(max, "Minimum age must be less than maximum age")
              : schema
          ),
        max: Yup.number()
          .required(getFieldRequiredMessage())
          .min(0, "Maximum age must be at least 0"),
      }),
      numberOfSeats: Yup.number()
        .required(getFieldRequiredMessage())
        .min(0, getFieldRequiredMessage()),
      price: Yup.number()
        .required(getFieldRequiredMessage())
        .positive("Price must be a positive number"),
      // discount: Yup.number()
      // .required(getFieldRequiredMessage())
      // .min(0, "Discount cannot be negative"),
      gender: Yup.string().required(getFieldRequiredMessage()),
    }),
    dateAndTimes: Yup.object().shape({
      numberOfDays: Yup.number()
        .required("Number of days is required")
        .positive("Number of days must be positive")
        .max(10, "Maximum 10 days allowed"),
      // duration: Yup.number()
      //   .required("Duration is required")
      //   .positive("Duration must be positive")
      //   .max(24, "Maximum 24 hours allowed"),
    }),
  };

  return createSchemaShape(shape);
};

const createCashbackSchema = () => {
  const shape = {
    title: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters"),
    titleAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
    promoText: Yup.array().of(
      Yup.object().shape({
        description: noOnlySpacesOrNumbers
          .required(getFieldRequiredMessage())
          .max(100, "Field must be at most 100 characters"),
        descriptionAr: noOnlySpacesOrNumbers
          .required(getFieldRequiredMessage())
          .max(100, "Field must be at most 100 characters")
          .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
      })
    ),
    levels: Yup.array().of(
      Yup.object().shape({
        title: noOnlySpacesOrNumbers
          .required(getFieldRequiredMessage())
          .max(100, "Field must be at most 100 characters"),
        titleAr: noOnlySpacesOrNumbers
          .required(getFieldRequiredMessage())
          .max(100, "Field must be at most 100 characters")
          .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
        value: Yup.number()
          .required("Number of bookings is required")
          .min(1, "Number of bookings must be at least 1")
          .integer("Number of bookings must be a whole number"),

        cashbackPercentage: Yup.string()
          .required("Cashback Percentage is required")
          .test(
            "is-valid-percentage",
            "Percentage must be between 5% and 100% in 5% increments",
            (value) => {
              const num = parseInt(value);
              return !isNaN(num) && num >= 5 && num <= 100;
            }
          ),
        expiredIn: Yup.string()
          .required("Expiration is required")
          .test(
            "is-valid-month",
            "Please select a value between 1-12 months",
            (value) => {
              const num = parseInt(value);
              return !isNaN(num) && num >= 1 && num <= 12;
            }
          ),
      })
    ),
  };

  return Yup.object().shape(shape);
};

const updateCompanyShare = () => {
  const shape = {
    trainerShare: Yup.number()
      .required(getFieldRequiredMessage())
      .min(0, "Trainer's share must be at least 0")
      .max(100, "Trainer's share cannot exceed 100"),
    companyShare: Yup.number()
      .required(getFieldRequiredMessage())
      .min(0, "Company's share must be at least 0")
      .max(100, "Company's share cannot exceed 100"),
    tax: Yup.number()
      .required(getFieldRequiredMessage())
      .min(0, "Company's share must be at least 0")
      .max(100, "Company's share cannot exceed 100"),
  };

  return createSchemaShape(shape);
};

const addBranchSchema = () => {
  const shape = {
    imageUrls: Yup.array().min(1, "Please add at least one amenity."),
    name: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters"),
    nameAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
    // address: noOnlySpacesOrNumbers
    //   .required(getFieldRequiredMessage())
    //   .max(250, "Field must be at most 250 characters"),
    // addressAr: noOnlySpacesOrNumbers
    //   .required(getFieldRequiredMessage())
    //   .max(250, "Field must be at most 250 characters")
    //   .matches(arabicNameOrNumberPattern, getValidArabicMessage()),

    cityId: Yup.string().required(getFieldRequiredMessage()),
    latitude: Yup.string().required(getFieldRequiredMessage()),
    // lockMac: Yup.string().required(getFieldRequiredMessage()),
    // wifiNetworkName: Yup.string().required(getFieldRequiredMessage()),
    // wifiNetworkPassword: Yup.string()
    //   .required(getFieldRequiredMessage())
    //   .min(6, "Field must be at least 5 characters"),
  };

  return createSchemaShape(shape);
};

const addCitySchema = () => {
  const shape = {
    name: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters"),
    nameAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
  };

  return createSchemaShape(shape);
};

const addAmenitySchema = () => {
  const shape = {
    name: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters"),
    nameAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
    image: Yup.array().min(1, getFieldRequiredMessage()),
  };

  return createSchemaShape(shape);
};

const addUserSchema = (mode) => {
  let shape = {
    name: noOnlySpacesOrNumbers.required(getFieldRequiredMessage()),
    role: Yup.string().required(getFieldRequiredMessage()),
    email: Yup.string()
      .required(getFieldRequiredMessage())
      .email()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        getValidEmail()
      ),
  };
  // if (mode === "ADD") {
  //   shape = {
  //     ...shape,
  //     password: Yup.string()
  //       .min(6, getMin6PasswordMessage())
  //       .matches(passwordPattern, getPasswordError())
  //       .required(getFieldRequiredMessage()),
  //     confirmPassword: Yup.string()
  //       .required(getFieldRequiredMessage())
  //       .oneOf([Yup.ref("password"), null], getPasswordMatchMessage()),
  //   };
  // }

  return createSchemaShape(shape);
};

const addRoleSchema = () => {
  const shape = {
    name: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters"),
    nameAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
  };

  return createSchemaShape(shape);
};

const addCouponSchema = () => {
  const shape = {
    code: noOnlySpacesOrNumbers.required(getFieldRequiredMessage()),
    // discountType: Yup.string()
    //   .oneOf(["fixed", "percentage"], getFieldRequiredMessage()) // Ensures valid values
    //   .required(getFieldRequiredMessage()),
    amount: Yup.number()
      .typeError(getFieldRequiredMessage()) // Ensures only numbers are accepted
      .required(getFieldRequiredMessage()) // Required field
      .when("discountType", {
        is: "percentage",
        then: (schema) =>
          schema
            .min(0, getFieldRequiredMessage())
            .max(100, getFieldRequiredMessage()), // 0-100 for percentage
        otherwise: (schema) => schema.min(0, getFieldRequiredMessage()), // Only positive numbers for fixed
      }),

    isMaxUsagePerCustomer: Yup.boolean(),
    isMaxUsageOfCustomers: Yup.boolean(),

    maxUsagePerCustomer: Yup.number()
      .typeError(getFieldRequiredMessage())
      .when("isMaxUsagePerCustomer", {
        is: false, // Required only when `isMaxUsagePerCustomer` is false
        then: (schema) =>
          schema
            .required(getFieldRequiredMessage())
            .min(1, getFieldRequiredMessage()),
      }),

    maxUsageOfCustomers: Yup.number()
      .typeError(getFieldRequiredMessage())
      .when("isMaxUsageOfCustomers", {
        is: false, // Required only when `isMaxUsageOfCustomers` is false
        then: (schema) =>
          schema
            .required(getFieldRequiredMessage())
            .min(1, getFieldRequiredMessage()),
      }),

    applicableBranches: Yup.array()
      .min(1, getFieldRequiredMessage())
      .required(getFieldRequiredMessage()),

    spaceTypes: Yup.array()
      .min(1, getFieldRequiredMessage())
      .required(getFieldRequiredMessage()),

    spaces: Yup.array()
      .min(1, getFieldRequiredMessage())
      .required(getFieldRequiredMessage()),

    startsAt: Yup.string().when("isNeverEnd", {
      is: false,
      then: (schema) => schema.required(getFieldRequiredMessage()),
      otherwise: (schema) => schema.notRequired(),
    }),

    expiresAt: Yup.string().when("isNeverEnd", {
      is: false,
      then: (schema) =>
        schema
          .required(getFieldRequiredMessage())
          .test(
            "is-after-start",
            "End date must be after start date",
            function (value) {
              const { startsAt } = this.parent;
              return startsAt && value
                ? new Date(value) >= new Date(startsAt)
                : true;
            }
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

    offerDetails: Yup.object().shape({
      name: Yup.string()
        // .required(getFieldRequiredMessage())
        .max(100, "Field must be at most 100 characters"),
      description: Yup.string()
        // .required(getFieldRequiredMessage())
        .max(1500, "Field must be at most 1500 characters"),
      nameAr: Yup.string()
        // .required(getFieldRequiredMessage())
        .max(100, "Field must be at most 100 characters")
        .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
      descriptionAr: Yup.string()
        // .required(getFieldRequiredMessage())
        .max(1500, "Field must be at most 1500 characters")
        .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
      // imageUrl: Yup.array()
      //   .min(1, getFieldRequiredMessage())
      //   .required(getFieldRequiredMessage()),
      // imageArUrl: Yup.array()
      //   .min(1, getFieldRequiredMessage())
      //   .required(getFieldRequiredMessage()),
    }),
  };

  return createSchemaShape(shape);
};

const rewardSchema = () => {
  const shape = {
    imageUrl: Yup.array().min(1, getFieldRequiredMessage()),

    name: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters"),
    nameAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
    // description: noOnlySpacesOrNumbers.required(getFieldRequiredMessage()),
    // descriptionAr: noOnlySpacesOrNumbers
    //   .required(getFieldRequiredMessage())
    //   .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
  };

  return createSchemaShape(shape);
};

const introductionSchema = () => {
  const shape = {
    introScreens: Yup.array().of(
      Yup.object().shape({
        imageUrl: Yup.string().required(getFieldRequiredMessage()),
        imageUrlAr: Yup.string().required(getFieldRequiredMessage()),
        name: noOnlySpacesOrNumbers
          .required(getFieldRequiredMessage())
          .max(100, "Maximum 100 characters allowed"),
        nameAr: noOnlySpacesOrNumbers
          .required(getFieldRequiredMessage())
          .matches(arabicNameOrNumberPattern, getValidArabicMessage())
          .max(100, "Maximum 100 characters allowed"),
        description: Yup.string().max(
          1500,
          "Field must be at most 1500 characters"
        ),
        // .required(getFieldRequiredMessage()),
        descriptionAr: Yup.string()
          .max(1500, "Field must be at most 1500 characters")
          .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
      })
    ),
  };

  return createSchemaShape(shape);
};

const addClosureSchema = () => {
  const shape = {
    cityId: Yup.string().required(getFieldRequiredMessage()),
    branchId: Yup.string().required(getFieldRequiredMessage()),
    spaceType: Yup.string().when("$hasClosedEntireBranch", {
      is: false,
      then: (schema) => schema.required(getFieldRequiredMessage()),
      otherwise: (schema) => schema.notRequired(),
    }),

    spaceId: Yup.array().when("$hasClosedEntireBranch", {
      is: false,
      then: (schema) => schema.min(1, "Please add at least one space type."),
      otherwise: (schema) => schema.notRequired(),
    }),
    dateAndTimes: Yup.object().shape({
      startDate: Yup.string().when("$type", {
        is: 1,
        then: (schema) => schema.required(getFieldRequiredMessage()),
        otherwise: (schema) => schema.notRequired(),
      }),
      endDate: Yup.string().when("$type", {
        is: 1,
        then: (schema) => schema.required(getFieldRequiredMessage()),
        otherwise: (schema) => schema.notRequired(),
      }),
      startTime: Yup.mixed().when("$type", {
        is: (val) => val === 1,
        then: (schema) => schema.required(getFieldRequiredMessage()),
        otherwise: (schema) => schema.notRequired(),
      }),
      endTime: Yup.mixed().when("$type", {
        is: (val) => val === 1,
        then: (schema) => schema.required(getFieldRequiredMessage()),
        otherwise: (schema) => schema.notRequired(),
      }),
      daysOfRecurrence: Yup.array().when("$type", {
        is: 2,
        then: (schema) =>
          schema
            .typeError("Please select at least one day.") // Optional: ensures it's an array
            .required("Please select at least one day.") // Required if type is 2
            .min(1, "Please select at least one day."),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    descriptionAr: Yup.string()
      .matches(arabicNameOrNumberPattern, getValidArabicMessage())
      .max(1500, "Field must be at most 1500 characters"),
  };

  return createSchemaShape(shape);
};

const sendNotificationSchema = () => {
  const shape = {
    title: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .when("type", {
        is: "all",
        then: (schema) =>
          schema.matches(
            englishWithoutNamePattern, // or arabicNameOrNumberPattern if you meant Arabic
            getNameVarFieldRequiredMessage()
          ),
        otherwise: (schema) =>
          schema.matches(
            englishWithNamePattern, // your alternate regex
            getNameVarFieldRequiredMessage()
          ),
      }),

    titleAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .when("type", {
        is: "all",
        then: (schema) =>
          schema.matches(arabicNameOrNumberPattern, getValidArabicMessage()),
        otherwise: (schema) =>
          schema.matches(arabicNameOrNumberPatternVar, getValidArabicMessage()),
      }),
    description: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters")
      .when("type", {
        is: "all",
        then: (schema) =>
          schema.matches(
            englishWithoutNamePattern, // or arabicNameOrNumberPattern if you meant Arabic
            getNameVarFieldRequiredMessage()
          ),
        otherwise: (schema) =>
          schema.matches(
            englishWithNamePattern, // your alternate regex
            getNameVarFieldRequiredMessage()
          ),
      }),
    descriptionAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters")
      .when("type", {
        is: "all",
        then: (schema) =>
          schema.matches(arabicNameOrNumberPattern, getValidArabicMessage()),
        otherwise: (schema) =>
          schema.matches(arabicNameOrNumberPatternVar, getValidArabicMessage()),
      }),
    type: Yup.string().required(getFieldRequiredMessage()),
    // scheduledTime: Yup.string().when("isScheduled", {
    //   is: true,
    //   then: (schema) => schema.required(getFieldRequiredMessage()),
    // }),

    roleType: Yup.number()
      .typeError(getFieldRequiredMessage())
      .when("type", {
        is: "customer_type", // Required only when `isMaxUsagePerCustomer` is false
        then: (schema) => schema.required(getFieldRequiredMessage()).min(1),
      }),
    days: Yup.number()
      .typeError(getFieldRequiredMessage())
      .when("type", {
        is: "last_booking", // Required only when `isMaxUsagePerCustomer` is false
        then: (schema) =>
          schema
            .required(getFieldRequiredMessage())
            .min(1, "Days must be at least 1")
            .max(365, "Days cannot be more than 365"),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
    count: Yup.number()
      .typeError(getFieldRequiredMessage())
      .when("type", {
        is: "number_of_bookings", // Required only when `isMaxUsagePerCustomer` is false
        then: (schema) => schema.required(getFieldRequiredMessage()),
      }),
    count: Yup.number()
      .typeError(getFieldRequiredMessage())
      .when("type", {
        is: "number_of_workshop_booked", // Required only when `isMaxUsagePerCustomer` is false
        then: (schema) =>
          schema
            .required(getFieldRequiredMessage())
            .min(1, "Days must be at least 1"),
      }),
    customers: Yup.array()
      .of(Yup.string())
      .when("type", {
        is: "specific_customers",
        then: (schema) =>
          schema
            .min(1, getFieldRequiredMessage()) // must select at least 1
            .required(getFieldRequiredMessage()),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
  };

  return createSchemaShape(shape);
};

const updateNotificationSchema = () => {
  const shape = {
    title: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters"),
    titleAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
    description: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters"),
    descriptionAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
  };

  return createSchemaShape(shape);
};

const referralValidationSchema = () => {
  const shape = {
    earnedLeafForSender: Yup.number()
      .required("Sender Leaves is required")
      .min(1, "Must be at least 1")
      // .max(100, "Cannot exceed 100")
      .typeError("Must be a number"),
    earnedLeafForReceiver: Yup.number()
      .required("Receiver Leaves is required")
      .min(1, "Must be at least 1")
      // .max(100, "Cannot exceed 100")
      .typeError("Must be a number"),
    expiredIn: Yup.string().required("Expiration period is required"),
  };

  return createSchemaShape(shape);
};

const addCashbackToCustomersSchema = () => {
  const shape = {
    title: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters"),
    titleAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(100, "Field must be at most 100 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
    description: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters"),
    descriptionAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
    amount: Yup.number()
      .required(getFieldRequiredMessage())
      .min(1, getFieldRequiredMessage())
      // .max(100, "Cannot exceed 100")
      .typeError(getOnlyNumMessage()),
    dateAndTime: Yup.string().required(getFieldRequiredMessage()),
  };

  return createSchemaShape(shape);
};

const cancellationPolicySchema = () => {
  const shape = {
    description: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters"),
    descriptionAr: noOnlySpacesOrNumbers
      .required(getFieldRequiredMessage())
      .max(1500, "Field must be at most 1500 characters")
      .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
  };

  return createSchemaShape(shape);
};

const globalSettingsSchema = () => {
  const shape = {
    vatInfo: Yup.object().shape({
      title: noOnlySpacesOrNumbers
        .required(getFieldRequiredMessage())
        .max(100, "Field must be at most 100 characters"),
      titleAr: noOnlySpacesOrNumbers
        .required(getFieldRequiredMessage())
        .max(100, "Field must be at most 100 characters")
        .matches(arabicNameOrNumberPattern, getValidArabicMessage()),
      value: Yup.number()
        .required(getFieldRequiredMessage())
        .min(0, getFieldRequiredMessage())
        .max(100, "Cannot exceed 100")
        .typeError(getOnlyNumMessage()),
      registeredNo: Yup.string().required(getFieldRequiredMessage()),
    }),
    cancelInfo: Yup.object().shape({
      valueInHours: Yup.number().when("checkBeforeCancel", {
        is: true,
        then: (schema) =>
          schema
            .required(getFieldRequiredMessage())
            .min(0, getFieldRequiredMessage())
            .max(48, "Cannot exceed 48 hours")
            .typeError(getOnlyNumMessage()),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
  };

  return createSchemaShape(shape);
};

const Schema = () => {
  const shape = {};

  return createSchemaShape(shape);
};

export {
  signUpSchema,
  loginSchema,
  orgnisationDetailsSchema,
  resetPasswordSchema,
  verifyCodeSchema,
  newPasswordSchema,
  addMeetingRoomSchema,
  addWorkspaceSchema,
  createWorkshopSchema,
  updateCompanyShare,
  addBranchSchema,
  addCitySchema,
  addAmenitySchema,
  addUserSchema,
  addRoleSchema,
  addCouponSchema,
  createCashbackSchema,
  rewardSchema,
  introductionSchema,
  addClosureSchema,
  sendNotificationSchema,
  updateNotificationSchema,
  referralValidationSchema,
  addCashbackToCustomersSchema,
  cancellationPolicySchema,
  globalSettingsSchema,
};
